module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/git-3-73a38a5b8cc3077715cf6755bcf987b9.svg";